// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2qZmZ","loaderOuter":"PageOverlayLoader_loaderOuter__3ffiF"};